export const MATCH_MEETING = 'name'
export const MATCH_ATTENDEE = 'attendees'
export const MATCH_TRANSCRIPT = 'transcript'
export const SEARCH_IN = [MATCH_MEETING, MATCH_ATTENDEE, MATCH_TRANSCRIPT]

const ANALYTICS_MATCH_MEETING = 'meeting_title'
const ANALYTICS_MATCH_ATTENDEE = 'attendee'
export const ANALYTICS_SEARCH_IN = [ANALYTICS_MATCH_MEETING, ANALYTICS_MATCH_ATTENDEE, MATCH_TRANSCRIPT]

export const MATCH_TYPE_MAPPING = {
  [MATCH_ATTENDEE]: ANALYTICS_MATCH_ATTENDEE,
  [MATCH_TRANSCRIPT]: MATCH_TRANSCRIPT,
  [MATCH_MEETING]: ANALYTICS_MATCH_MEETING
}

export const SORT_OPTIONS = [
  'BEST_MATCH',
  'MOST_RECENT',
  'LEAST_RECENT',
]
